import { useState } from 'react';
import { Spinner, HStack, Icon, Text } from '@chakra-ui/react';

import { SFDownloadOutlined } from '@assets/icons';
import {
  getDocumentMetadataFromCard,
  downloadFileFromBatch,
  extractBatchIdFromTags
} from '@util/helpers';
import { useBatches } from '@services/query-services/batches.query-service';

export default function DocumentDownloadButton({ card }) {
  const [isDownloading, setIsDownloading] = useState(false);

  // Extract batch_id from card tags
  const batchId = extractBatchIdFromTags(card);

  // Fetch the batch data
  const { data: batches, isLoading: isBatchLoading } = useBatches(
    { pageSize: 100, ids: [batchId] },
    { enabled: !!batchId }
  );
  const batch = batches ? batches[0] : null;

  // Don't render if no batch ID found or still loading batch
  if (!batchId || isBatchLoading || !batch) {
    return null;
  }

  return (
    <HStack
      layerStyle='section-card'
      p={4}
      gap={4}
      w='full'
      onClick={() => downloadFileFromBatch(batch, setIsDownloading)}
      cursor='pointer'
      role='button'
    >
      {isDownloading ? (
        <Spinner
          size='sm'
          speed='0.8s'
          color='brandPrimary.primary'
          mr={1}
          data-testid='loading-spinner'
        />
      ) : (
        <Icon
          as={SFDownloadOutlined}
          color='brandPrimary.primary'
          boxSize={7}
        />
      )}
      <Text variant='content-section-header'>{getDocumentMetadataFromCard(card)?.name}</Text>
    </HStack>
  );
}
